import styles from "./customer.module.css";
import { useState } from "react";
import { AiFillLeftCircle } from "react-icons/ai";
import { FaTrash } from "react-icons/fa";
import Modal from "./modal/Modal";
import DelModal from "./modal/DelModal";
import BoxCustomer from "./BoxCustomer";

const CustomerManagement = () => {
  const [img, setimg] = useState("");
  const [selectedItem, setSelectedItem] = useState(1);
  const [customers, setCustomers] = useState([
    {
      name: "سارا محمود زاده",
      mobile: "09211086558",
      status: true,
      codeMeli: "2110705858",
      rank: 7,
      barchasb: [],
      id: 0,
    },
    {
      name: "نازنین خاتمی  زاده",
      mobile: "09211086558",
      status: false,
      codeMeli: "2110705858",
      rank: 7,
      barchasb: [],
      id: 1,
    },
    {
      name: "سعیده مقصودی  ",
      mobile: "09211086558",
      status: true,
      codeMeli: "2110705858",
      rank: 7,
      barchasb: [],
      id: 2,
    },
    {
      name: "سارا محمود زاده",
      mobile: "09211086558",
      status: false,
      codeMeli: "2110705858",
      rank: 7,
      barchasb: [],
      id: 3,
    },
    {
      name: "سارا محمود زاده",
      mobile: "09211086558",
      status: true,
      codeMeli: "2110705858",
      rank: 7,
      barchasb: [],
      id: 4,
    },
    {
      name: "سارا محمود زاده",
      mobile: "09211086558",
      status: true,
      codeMeli: "2110705858",
      rank: 7,
      barchasb: [],
      id: 5,
    },
  ]);
  const deleteHandler = (id) => {
    const filterItem = customers.filter((p) => p.id !== id);
    setCustomers(filterItem);
  };

  const changeHandlerDaste = (option) => {
    setCustomers((prev) => {
      let temp = [...prev];
      temp[selectedItem].barchasb = option;
      return [...temp];
    });
  };
  const optionDasteBandi = [
    { label: "باشگاه مشتریان ", value: "custom" },
    { label: " کاربر ویژه", value: "spcial" },
    { label: " کاربر عادی", value: "normal" },
  ];

  return (
    <div className="container w-100">
      {customers.map((item, index) => {
        return (
          <div>
            <BoxCustomer
              item={item}
              key={item.id}
              customers={customers}
              selectedItem={selectedItem}
              setSelectedItem={setSelectedItem}
              setCustomers={setCustomers}
              index={index}
              deleteHandler={() => deleteHandler(item.id)}
            />
          </div>
        );
      })}
      <div className="d-flex justify-content-center mt-4">
        <AiFillLeftCircle className={styles.circl} />
      </div>

      <Modal
        index={selectedItem}
        customers={customers}
        optionDasteBandi={optionDasteBandi}
        changeHandlerDaste={changeHandlerDaste}
        EditUser={setCustomers}
      />
      {/* <!--Modal Trash--> */}
      <DelModal
        index={selectedItem}
        customers={customers}
        deleteHandler={deleteHandler}
      />
      {/* <!--Modal Edit--> */}
    </div>
  );
};

export default CustomerManagement;
